@if (viewModel$ | async; as viewModel) {
    @if (hasBetslipErrors(viewModel.errors) || viewModel.hasComboPrevention) {
        <div class="pc-text betslip-bet-errors">
            @if (getError(viewModel.errors); as error) {
                @if (getErrorMessage(error) | async; as message) {
                    <ng-container *msShowInEpcot="false">
                        <a class="linkbox betslip-error sticky" [ngClass]="{ 'add-header': isBetNotPlaced(error) || isExtendedMessage(message) }">
                            @if (isBetNotPlaced(error)) {
                                <h4 class="theme-error-i">{{ siteCore.betslip.messages.BetNotPlaced }}</h4>
                            }
                            @if (isExtendedMessage(message)) {
                                <h4 class="theme-error-i">{{ message.title }}</h4>
                            }
                            @if (!isExtendedMessage(message)) {
                                <p [innerHTML]="message" (click)="redirectFromErrorMessage($event, error)"></p>
                            }
                            @if (isExtendedMessage(message)) {
                                <p [innerHTML]="message.message | msTrust: 'html'" (click)="message.callback && message.callback!.call(error)"></p>
                            }
                        </a>
                    </ng-container>
                    <ng-container *msShowInEpcot="true">
                        <div class="betslip-error-notification">
                            @if (isExtendedMessage(message)) {
                                <div (click)="message.callback && message.callback!.call(error)">
                                    <ms-epcot-notification
                                        [message]="message.message | msTrust: 'html'"
                                        [notificationHeaderTitle]="
                                            isBetNotPlaced(error) ? siteCore.betslip.messages.BetNotPlaced : '' + ' ' + message.title
                                        "
                                        [notificationType]="isBetNotPlaced(error) ? 'error' : 'info'" />
                                </div>
                            } @else {
                                <div (click)="redirectFromErrorMessage($event, error)">
                                    <ms-epcot-notification
                                        [message]="message"
                                        [notificationHeaderTitle]="isBetNotPlaced(error) ? siteCore.betslip.messages.BetNotPlaced : ''"
                                        [notificationType]="isBetNotPlaced(error) ? 'error' : 'info'" />
                                </div>
                            }
                        </div>
                    </ng-container>
                }
            }
            @if (viewModel.hasComboPrevention) {
                <a class="linkbox betslip-error sticky" *msShowInEpcot="false">
                    <p class="theme-error-i">{{ siteCore.betslip.errors.NonCombinablePicks }}</p>
                </a>
                <ng-container *msShowInEpcot="true">
                    <ms-epcot-notification [message]="siteCore.betslip.errors.NonCombinablePicks" [notificationType]="'warning'" />
                </ng-container>
            }
        </div>
    }
}
